// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/affiliate_network.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { DateRange, ListSort, Ownership, Pagination, PaginationMeta, TagRef } from "./common_pb.js";
import { ConversionStatus } from "./conversion_pb.js";
import { StatsRow } from "./reporting_pb.js";
import { AttributionBasis } from "./analytics_pb.js";

/**
 * How the resolver reads one partner word today.
 *
 * @generated from enum tracker.v1.StatusWordSource
 */
export enum StatusWordSource {
  /**
   * @generated from enum value: STATUS_WORD_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The network's own mapping names it.
   *
   * @generated from enum value: STATUS_WORD_SOURCE_NETWORK = 1;
   */
  NETWORK = 1,

  /**
   * The tracker's global dictionary knows it (approved, pending, trash …).
   *
   * @generated from enum value: STATUS_WORD_SOURCE_GLOBAL = 2;
   */
  GLOBAL = 2,

  /**
   * Nobody does: its postbacks are held as unknown_status until mapped.
   *
   * @generated from enum value: STATUS_WORD_SOURCE_UNMAPPED = 3;
   */
  UNMAPPED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(StatusWordSource)
proto3.util.setEnumType(StatusWordSource, "tracker.v1.StatusWordSource", [
  { no: 0, name: "STATUS_WORD_SOURCE_UNSPECIFIED" },
  { no: 1, name: "STATUS_WORD_SOURCE_NETWORK" },
  { no: 2, name: "STATUS_WORD_SOURCE_GLOBAL" },
  { no: 3, name: "STATUS_WORD_SOURCE_UNMAPPED" },
]);

/**
 * StaleConversionPolicy decides the fate of a conversion whose attributed
 * click is older than attribution_window_seconds.
 *
 * @generated from enum tracker.v1.StaleConversionPolicy
 */
export enum StaleConversionPolicy {
  /**
   * @generated from enum value: STALE_CONVERSION_POLICY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * keep status, stamp reject_reason
   *
   * @generated from enum value: STALE_CONVERSION_POLICY_FLAG = 1;
   */
  FLAG = 1,

  /**
   * store as REJECTED
   *
   * @generated from enum value: STALE_CONVERSION_POLICY_REJECT = 2;
   */
  REJECT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(StaleConversionPolicy)
proto3.util.setEnumType(StaleConversionPolicy, "tracker.v1.StaleConversionPolicy", [
  { no: 0, name: "STALE_CONVERSION_POLICY_UNSPECIFIED" },
  { no: 1, name: "STALE_CONVERSION_POLICY_FLAG" },
  { no: 2, name: "STALE_CONVERSION_POLICY_REJECT" },
]);

/**
 * @generated from enum tracker.v1.PayoutModel
 */
export enum PayoutModel {
  /**
   * @generated from enum value: PAYOUT_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYOUT_MODEL_CPA = 1;
   */
  CPA = 1,

  /**
   * @generated from enum value: PAYOUT_MODEL_CPL = 2;
   */
  CPL = 2,

  /**
   * @generated from enum value: PAYOUT_MODEL_CPS = 3;
   */
  CPS = 3,

  /**
   * @generated from enum value: PAYOUT_MODEL_REVSHARE = 4;
   */
  REVSHARE = 4,

  /**
   * @generated from enum value: PAYOUT_MODEL_CPC = 5;
   */
  CPC = 5,

  /**
   * @generated from enum value: PAYOUT_MODEL_CPM = 6;
   */
  CPM = 6,

  /**
   * @generated from enum value: PAYOUT_MODEL_CPI = 7;
   */
  CPI = 7,

  /**
   * @generated from enum value: PAYOUT_MODEL_DOI = 8;
   */
  DOI = 8,

  /**
   * @generated from enum value: PAYOUT_MODEL_SOI = 9;
   */
  SOI = 9,
}
// Retrieve enum metadata with: proto3.getEnumType(PayoutModel)
proto3.util.setEnumType(PayoutModel, "tracker.v1.PayoutModel", [
  { no: 0, name: "PAYOUT_MODEL_UNSPECIFIED" },
  { no: 1, name: "PAYOUT_MODEL_CPA" },
  { no: 2, name: "PAYOUT_MODEL_CPL" },
  { no: 3, name: "PAYOUT_MODEL_CPS" },
  { no: 4, name: "PAYOUT_MODEL_REVSHARE" },
  { no: 5, name: "PAYOUT_MODEL_CPC" },
  { no: 6, name: "PAYOUT_MODEL_CPM" },
  { no: 7, name: "PAYOUT_MODEL_CPI" },
  { no: 8, name: "PAYOUT_MODEL_DOI" },
  { no: 9, name: "PAYOUT_MODEL_SOI" },
]);

/**
 * @generated from enum tracker.v1.AffiliateNetworkStatus
 */
export enum AffiliateNetworkStatus {
  /**
   * @generated from enum value: AFFILIATE_NETWORK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AFFILIATE_NETWORK_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: AFFILIATE_NETWORK_STATUS_PAUSED = 2;
   */
  PAUSED = 2,

  /**
   * @generated from enum value: AFFILIATE_NETWORK_STATUS_ARCHIVED = 3;
   */
  ARCHIVED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AffiliateNetworkStatus)
proto3.util.setEnumType(AffiliateNetworkStatus, "tracker.v1.AffiliateNetworkStatus", [
  { no: 0, name: "AFFILIATE_NETWORK_STATUS_UNSPECIFIED" },
  { no: 1, name: "AFFILIATE_NETWORK_STATUS_ACTIVE" },
  { no: 2, name: "AFFILIATE_NETWORK_STATUS_PAUSED" },
  { no: 3, name: "AFFILIATE_NETWORK_STATUS_ARCHIVED" },
]);

/**
 * AffiliateNetwork is the inbound-postback issuer: it owns the offers and
 * fires S2S conversions at /pb/{network_id}/{token}.
 *
 * @generated from message tracker.v1.AffiliateNetwork
 */
export class AffiliateNetwork extends Message<AffiliateNetwork> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string currency = 4;
   */
  currency = "";

  /**
   * @generated from field: tracker.v1.PayoutModel default_payout_model = 5;
   */
  defaultPayoutModel = PayoutModel.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.PostbackSecurity postback_security = 6;
   */
  postbackSecurity?: PostbackSecurity;

  /**
   * generated, read-only
   *
   * @generated from field: string inbound_postback_url = 7;
   */
  inboundPostbackUrl = "";

  /**
   * @generated from field: tracker.v1.AffiliateNetworkStatus status = 9;
   */
  status = AffiliateNetworkStatus.UNSPECIFIED;

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 10;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 11;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string notes = 12;
   */
  notes = "";

  /**
   * @generated from field: string created_at = 13;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 14;
   */
  updatedAt = "";

  /**
   * template_name is a free-form provider tag (e.g. "leadbit", "adcombo");
   * offer_param is the query key carrying the offer id in its postbacks.
   *
   * @generated from field: string offer_param = 16;
   */
  offerParam = "";

  /**
   * @generated from field: string template_name = 18;
   */
  templateName = "";

  /**
   * Attribution policy: how old the attributed click may be when a
   * conversion arrives (default 30d) and what to do beyond the window.
   *
   * @generated from field: int64 attribution_window_seconds = 19;
   */
  attributionWindowSeconds = protoInt64.zero;

  /**
   * @generated from field: tracker.v1.StaleConversionPolicy stale_conversion_policy = 20;
   */
  staleConversionPolicy = StaleConversionPolicy.UNSPECIFIED;

  /**
   * How this partner's postbacks read: which params carry the goal and the
   * status, what each partner word means, the defaults. Set — even empty —
   * replaces the stored mapping; unset on UpdateAffiliateNetwork keeps it (a
   * client that does not know the field never wipes a live mapping).
   *
   * @generated from field: tracker.v1.ConversionMapping conversion_mapping = 22;
   */
  conversionMapping?: ConversionMapping;

  /**
   * The partner's own cabinet (https://…), for «открыть у партнёрки». "" = none.
   *
   * @generated from field: string cabinet_url = 26;
   */
  cabinetUrl = "";

  /**
   * Silence longer than this (seconds) with no postback from the partner is
   * a problem in «Здоровье данных» (issue postbacks_silent). 0 = never.
   *
   * @generated from field: int64 silence_alert_seconds = 27;
   */
  silenceAlertSeconds = protoInt64.zero;

  /**
   * inbound_postback_url on the platform's own postback host (the first of
   * EDGE_POSTBACK_ALIASES): the address to paste into the partner's cabinet
   * when no campaign domain is meant. "" when the platform has none.
   * Generated, read-only.
   *
   * @generated from field: string postback_url = 28;
   */
  postbackUrl = "";

  constructor(data?: PartialMessage<AffiliateNetwork>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.AffiliateNetwork";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "default_payout_model", kind: "enum", T: proto3.getEnumType(PayoutModel) },
    { no: 6, name: "postback_security", kind: "message", T: PostbackSecurity },
    { no: 7, name: "inbound_postback_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(AffiliateNetworkStatus) },
    { no: 10, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 11, name: "ownership", kind: "message", T: Ownership },
    { no: 12, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "offer_param", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "template_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "attribution_window_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "stale_conversion_policy", kind: "enum", T: proto3.getEnumType(StaleConversionPolicy) },
    { no: 22, name: "conversion_mapping", kind: "message", T: ConversionMapping },
    { no: 26, name: "cabinet_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "silence_alert_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 28, name: "postback_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AffiliateNetwork {
    return new AffiliateNetwork().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AffiliateNetwork {
    return new AffiliateNetwork().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AffiliateNetwork {
    return new AffiliateNetwork().fromJsonString(jsonString, options);
  }

  static equals(a: AffiliateNetwork | PlainMessage<AffiliateNetwork> | undefined, b: AffiliateNetwork | PlainMessage<AffiliateNetwork> | undefined): boolean {
    return proto3.util.equals(AffiliateNetwork, a, b);
  }
}

/**
 * ConversionMapping is one layer of the postback resolver (internal/convmap):
 * the network's, or an offer's override of it. Every word is compared
 * lower-cased; an empty mapping contributes nothing and the resolver falls to
 * the Keitaro dictionaries, the global aliases and the defaults.
 *
 * @generated from message tracker.v1.ConversionMapping
 */
export class ConversionMapping extends Message<ConversionMapping> {
  /**
   * Query params carrying the goal / the status, checked in order.
   *
   * @generated from field: repeated string goal_params = 1;
   */
  goalParams: string[] = [];

  /**
   * @generated from field: repeated string status_params = 2;
   */
  statusParams: string[] = [];

  /**
   * A partner word → a goal key of the workspace registry.
   *
   * @generated from field: repeated tracker.v1.GoalWord goals = 3;
   */
  goals: GoalWord[] = [];

  /**
   * A partner word → our status. Unmapped words land on HOLD and are listed
   * by ListNetworkStatuses until someone maps them.
   *
   * @generated from field: repeated tracker.v1.StatusWord statuses = 4;
   */
  statuses: StatusWord[] = [];

  /**
   * Goal when no word matched; "" = the workspace fallback goal.
   *
   * @generated from field: string default_goal = 5;
   */
  defaultGoal = "";

  /**
   * Status when no word matched; UNSPECIFIED = HOLD (an unread word is not a sale).
   *
   * @generated from field: tracker.v1.ConversionStatus default_status = 6;
   */
  defaultStatus = ConversionStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<ConversionMapping>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ConversionMapping";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "goal_params", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "status_params", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "goals", kind: "message", T: GoalWord, repeated: true },
    { no: 4, name: "statuses", kind: "message", T: StatusWord, repeated: true },
    { no: 5, name: "default_goal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "default_status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConversionMapping {
    return new ConversionMapping().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConversionMapping {
    return new ConversionMapping().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConversionMapping {
    return new ConversionMapping().fromJsonString(jsonString, options);
  }

  static equals(a: ConversionMapping | PlainMessage<ConversionMapping> | undefined, b: ConversionMapping | PlainMessage<ConversionMapping> | undefined): boolean {
    return proto3.util.equals(ConversionMapping, a, b);
  }
}

/**
 * @generated from message tracker.v1.GoalWord
 */
export class GoalWord extends Message<GoalWord> {
  /**
   * @generated from field: string word = 1;
   */
  word = "";

  /**
   * @generated from field: string goal_key = 2;
   */
  goalKey = "";

  constructor(data?: PartialMessage<GoalWord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GoalWord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "word", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goal_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GoalWord {
    return new GoalWord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GoalWord {
    return new GoalWord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GoalWord {
    return new GoalWord().fromJsonString(jsonString, options);
  }

  static equals(a: GoalWord | PlainMessage<GoalWord> | undefined, b: GoalWord | PlainMessage<GoalWord> | undefined): boolean {
    return proto3.util.equals(GoalWord, a, b);
  }
}

/**
 * @generated from message tracker.v1.StatusWord
 */
export class StatusWord extends Message<StatusWord> {
  /**
   * @generated from field: string word = 1;
   */
  word = "";

  /**
   * @generated from field: tracker.v1.ConversionStatus status = 2;
   */
  status = ConversionStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<StatusWord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.StatusWord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "word", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StatusWord {
    return new StatusWord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StatusWord {
    return new StatusWord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StatusWord {
    return new StatusWord().fromJsonString(jsonString, options);
  }

  static equals(a: StatusWord | PlainMessage<StatusWord> | undefined, b: StatusWord | PlainMessage<StatusWord> | undefined): boolean {
    return proto3.util.equals(StatusWord, a, b);
  }
}

/**
 * NetworkStatusWord is one row of «Как читать статусы»: a word the partner
 * sent in the window or the network's mapping names, what it means now and
 * how many postbacks / leads carried it.
 *
 * @generated from message tracker.v1.NetworkStatusWord
 */
export class NetworkStatusWord extends Message<NetworkStatusWord> {
  /**
   * @generated from field: string word = 1;
   */
  word = "";

  /**
   * UNSPECIFIED when unmapped.
   *
   * @generated from field: tracker.v1.ConversionStatus status = 2;
   */
  status = ConversionStatus.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.StatusWordSource source = 3;
   */
  source = StatusWordSource.UNSPECIFIED;

  /**
   * Postbacks journaled with this word in the window (any result).
   *
   * @generated from field: int64 postbacks = 4;
   */
  postbacks = protoInt64.zero;

  /**
   * Distinct conversions (leads) those postbacks are about.
   *
   * @generated from field: int64 leads = 5;
   */
  leads = protoInt64.zero;

  /**
   * RFC3339; "" = not seen in the window
   *
   * @generated from field: string last_seen_at = 6;
   */
  lastSeenAt = "";

  constructor(data?: PartialMessage<NetworkStatusWord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.NetworkStatusWord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "word", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 3, name: "source", kind: "enum", T: proto3.getEnumType(StatusWordSource) },
    { no: 4, name: "postbacks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "leads", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "last_seen_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NetworkStatusWord {
    return new NetworkStatusWord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NetworkStatusWord {
    return new NetworkStatusWord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NetworkStatusWord {
    return new NetworkStatusWord().fromJsonString(jsonString, options);
  }

  static equals(a: NetworkStatusWord | PlainMessage<NetworkStatusWord> | undefined, b: NetworkStatusWord | PlainMessage<NetworkStatusWord> | undefined): boolean {
    return proto3.util.equals(NetworkStatusWord, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListNetworkStatusesRequest
 */
export class ListNetworkStatusesRequest extends Message<ListNetworkStatusesRequest> {
  /**
   * @generated from field: string network_id = 1;
   */
  networkId = "";

  /**
   * Default the last 30 days.
   *
   * @generated from field: tracker.v1.DateRange range = 2;
   */
  range?: DateRange;

  constructor(data?: PartialMessage<ListNetworkStatusesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListNetworkStatusesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListNetworkStatusesRequest {
    return new ListNetworkStatusesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListNetworkStatusesRequest {
    return new ListNetworkStatusesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListNetworkStatusesRequest {
    return new ListNetworkStatusesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListNetworkStatusesRequest | PlainMessage<ListNetworkStatusesRequest> | undefined, b: ListNetworkStatusesRequest | PlainMessage<ListNetworkStatusesRequest> | undefined): boolean {
    return proto3.util.equals(ListNetworkStatusesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListNetworkStatusesResponse
 */
export class ListNetworkStatusesResponse extends Message<ListNetworkStatusesResponse> {
  /**
   * Unmapped first, then by postbacks.
   *
   * @generated from field: repeated tracker.v1.NetworkStatusWord items = 1;
   */
  items: NetworkStatusWord[] = [];

  /**
   * Leads whose status word nobody has mapped — counted as HOLD meanwhile.
   *
   * @generated from field: int64 unmapped_leads = 2;
   */
  unmappedLeads = protoInt64.zero;

  constructor(data?: PartialMessage<ListNetworkStatusesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListNetworkStatusesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: NetworkStatusWord, repeated: true },
    { no: 2, name: "unmapped_leads", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListNetworkStatusesResponse {
    return new ListNetworkStatusesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListNetworkStatusesResponse {
    return new ListNetworkStatusesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListNetworkStatusesResponse {
    return new ListNetworkStatusesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListNetworkStatusesResponse | PlainMessage<ListNetworkStatusesResponse> | undefined, b: ListNetworkStatusesResponse | PlainMessage<ListNetworkStatusesResponse> | undefined): boolean {
    return proto3.util.equals(ListNetworkStatusesResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.PostbackSecurity
 */
export class PostbackSecurity extends Message<PostbackSecurity> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: repeated string ip_allowlist = 2;
   */
  ipAllowlist: string[] = [];

  /**
   * @generated from field: bool require_https = 3;
   */
  requireHttps = false;

  constructor(data?: PartialMessage<PostbackSecurity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PostbackSecurity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ip_allowlist", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "require_https", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PostbackSecurity {
    return new PostbackSecurity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PostbackSecurity {
    return new PostbackSecurity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PostbackSecurity {
    return new PostbackSecurity().fromJsonString(jsonString, options);
  }

  static equals(a: PostbackSecurity | PlainMessage<PostbackSecurity> | undefined, b: PostbackSecurity | PlainMessage<PostbackSecurity> | undefined): boolean {
    return proto3.util.equals(PostbackSecurity, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListAffiliateNetworksRequest
 */
export class ListAffiliateNetworksRequest extends Message<ListAffiliateNetworksRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: repeated tracker.v1.AffiliateNetworkStatus statuses = 2;
   */
  statuses: AffiliateNetworkStatus[] = [];

  /**
   * @generated from field: string search = 3;
   */
  search = "";

  /**
   * @generated from field: repeated string tag_ids = 4;
   */
  tagIds: string[] = [];

  /**
   * Networks by their own id.
   *
   * @generated from field: repeated string ids = 5;
   */
  ids: string[] = [];

  /**
   * name | created_at (default: created_at, newest first).
   *
   * @generated from field: tracker.v1.ListSort sort = 6;
   */
  sort?: ListSort;

  constructor(data?: PartialMessage<ListAffiliateNetworksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListAffiliateNetworksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "statuses", kind: "enum", T: proto3.getEnumType(AffiliateNetworkStatus), repeated: true },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "sort", kind: "message", T: ListSort },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAffiliateNetworksRequest {
    return new ListAffiliateNetworksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAffiliateNetworksRequest {
    return new ListAffiliateNetworksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAffiliateNetworksRequest {
    return new ListAffiliateNetworksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAffiliateNetworksRequest | PlainMessage<ListAffiliateNetworksRequest> | undefined, b: ListAffiliateNetworksRequest | PlainMessage<ListAffiliateNetworksRequest> | undefined): boolean {
    return proto3.util.equals(ListAffiliateNetworksRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListAffiliateNetworksResponse
 */
export class ListAffiliateNetworksResponse extends Message<ListAffiliateNetworksResponse> {
  /**
   * @generated from field: repeated tracker.v1.AffiliateNetwork items = 1;
   */
  items: AffiliateNetwork[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListAffiliateNetworksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListAffiliateNetworksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: AffiliateNetwork, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAffiliateNetworksResponse {
    return new ListAffiliateNetworksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAffiliateNetworksResponse {
    return new ListAffiliateNetworksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAffiliateNetworksResponse {
    return new ListAffiliateNetworksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAffiliateNetworksResponse | PlainMessage<ListAffiliateNetworksResponse> | undefined, b: ListAffiliateNetworksResponse | PlainMessage<ListAffiliateNetworksResponse> | undefined): boolean {
    return proto3.util.equals(ListAffiliateNetworksResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetAffiliateNetworkRequest
 */
export class GetAffiliateNetworkRequest extends Message<GetAffiliateNetworkRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetAffiliateNetworkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetAffiliateNetworkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAffiliateNetworkRequest {
    return new GetAffiliateNetworkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAffiliateNetworkRequest {
    return new GetAffiliateNetworkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAffiliateNetworkRequest {
    return new GetAffiliateNetworkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAffiliateNetworkRequest | PlainMessage<GetAffiliateNetworkRequest> | undefined, b: GetAffiliateNetworkRequest | PlainMessage<GetAffiliateNetworkRequest> | undefined): boolean {
    return proto3.util.equals(GetAffiliateNetworkRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetAffiliateNetworkResponse
 */
export class GetAffiliateNetworkResponse extends Message<GetAffiliateNetworkResponse> {
  /**
   * @generated from field: tracker.v1.AffiliateNetwork network = 1;
   */
  network?: AffiliateNetwork;

  constructor(data?: PartialMessage<GetAffiliateNetworkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetAffiliateNetworkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network", kind: "message", T: AffiliateNetwork },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAffiliateNetworkResponse {
    return new GetAffiliateNetworkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAffiliateNetworkResponse {
    return new GetAffiliateNetworkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAffiliateNetworkResponse {
    return new GetAffiliateNetworkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAffiliateNetworkResponse | PlainMessage<GetAffiliateNetworkResponse> | undefined, b: GetAffiliateNetworkResponse | PlainMessage<GetAffiliateNetworkResponse> | undefined): boolean {
    return proto3.util.equals(GetAffiliateNetworkResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateAffiliateNetworkRequest
 */
export class CreateAffiliateNetworkRequest extends Message<CreateAffiliateNetworkRequest> {
  /**
   * @generated from field: tracker.v1.AffiliateNetwork network = 1;
   */
  network?: AffiliateNetwork;

  constructor(data?: PartialMessage<CreateAffiliateNetworkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateAffiliateNetworkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network", kind: "message", T: AffiliateNetwork },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAffiliateNetworkRequest {
    return new CreateAffiliateNetworkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAffiliateNetworkRequest {
    return new CreateAffiliateNetworkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAffiliateNetworkRequest {
    return new CreateAffiliateNetworkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAffiliateNetworkRequest | PlainMessage<CreateAffiliateNetworkRequest> | undefined, b: CreateAffiliateNetworkRequest | PlainMessage<CreateAffiliateNetworkRequest> | undefined): boolean {
    return proto3.util.equals(CreateAffiliateNetworkRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateAffiliateNetworkResponse
 */
export class CreateAffiliateNetworkResponse extends Message<CreateAffiliateNetworkResponse> {
  /**
   * @generated from field: tracker.v1.AffiliateNetwork network = 1;
   */
  network?: AffiliateNetwork;

  constructor(data?: PartialMessage<CreateAffiliateNetworkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateAffiliateNetworkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network", kind: "message", T: AffiliateNetwork },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAffiliateNetworkResponse {
    return new CreateAffiliateNetworkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAffiliateNetworkResponse {
    return new CreateAffiliateNetworkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAffiliateNetworkResponse {
    return new CreateAffiliateNetworkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAffiliateNetworkResponse | PlainMessage<CreateAffiliateNetworkResponse> | undefined, b: CreateAffiliateNetworkResponse | PlainMessage<CreateAffiliateNetworkResponse> | undefined): boolean {
    return proto3.util.equals(CreateAffiliateNetworkResponse, a, b);
  }
}

/**
 * A changed conversion_mapping is published at once as the network's postback
 * policy (every later postback reads it).
 *
 * @generated from message tracker.v1.UpdateAffiliateNetworkRequest
 */
export class UpdateAffiliateNetworkRequest extends Message<UpdateAffiliateNetworkRequest> {
  /**
   * @generated from field: tracker.v1.AffiliateNetwork network = 1;
   */
  network?: AffiliateNetwork;

  /**
   * Apply again the postbacks held as unknown_status whose word this update
   * maps for the first time (at most 1000 per word) — the table's «Сохранить»
   * on words that were waiting. False leaves them held.
   *
   * @generated from field: bool replay_newly_mapped = 2;
   */
  replayNewlyMapped = false;

  constructor(data?: PartialMessage<UpdateAffiliateNetworkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateAffiliateNetworkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network", kind: "message", T: AffiliateNetwork },
    { no: 2, name: "replay_newly_mapped", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAffiliateNetworkRequest {
    return new UpdateAffiliateNetworkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAffiliateNetworkRequest {
    return new UpdateAffiliateNetworkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAffiliateNetworkRequest {
    return new UpdateAffiliateNetworkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAffiliateNetworkRequest | PlainMessage<UpdateAffiliateNetworkRequest> | undefined, b: UpdateAffiliateNetworkRequest | PlainMessage<UpdateAffiliateNetworkRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAffiliateNetworkRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateAffiliateNetworkResponse
 */
export class UpdateAffiliateNetworkResponse extends Message<UpdateAffiliateNetworkResponse> {
  /**
   * @generated from field: tracker.v1.AffiliateNetwork network = 1;
   */
  network?: AffiliateNetwork;

  /**
   * The postbacks scheduled by replay_newly_mapped.
   *
   * @generated from field: repeated string scheduled_event_ids = 2;
   */
  scheduledEventIds: string[] = [];

  constructor(data?: PartialMessage<UpdateAffiliateNetworkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateAffiliateNetworkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network", kind: "message", T: AffiliateNetwork },
    { no: 2, name: "scheduled_event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAffiliateNetworkResponse {
    return new UpdateAffiliateNetworkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAffiliateNetworkResponse {
    return new UpdateAffiliateNetworkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAffiliateNetworkResponse {
    return new UpdateAffiliateNetworkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAffiliateNetworkResponse | PlainMessage<UpdateAffiliateNetworkResponse> | undefined, b: UpdateAffiliateNetworkResponse | PlainMessage<UpdateAffiliateNetworkResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAffiliateNetworkResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveAffiliateNetworkRequest
 */
export class ArchiveAffiliateNetworkRequest extends Message<ArchiveAffiliateNetworkRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ArchiveAffiliateNetworkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveAffiliateNetworkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveAffiliateNetworkRequest {
    return new ArchiveAffiliateNetworkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveAffiliateNetworkRequest {
    return new ArchiveAffiliateNetworkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveAffiliateNetworkRequest {
    return new ArchiveAffiliateNetworkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveAffiliateNetworkRequest | PlainMessage<ArchiveAffiliateNetworkRequest> | undefined, b: ArchiveAffiliateNetworkRequest | PlainMessage<ArchiveAffiliateNetworkRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveAffiliateNetworkRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveAffiliateNetworkResponse
 */
export class ArchiveAffiliateNetworkResponse extends Message<ArchiveAffiliateNetworkResponse> {
  constructor(data?: PartialMessage<ArchiveAffiliateNetworkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveAffiliateNetworkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveAffiliateNetworkResponse {
    return new ArchiveAffiliateNetworkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveAffiliateNetworkResponse {
    return new ArchiveAffiliateNetworkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveAffiliateNetworkResponse {
    return new ArchiveAffiliateNetworkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveAffiliateNetworkResponse | PlainMessage<ArchiveAffiliateNetworkResponse> | undefined, b: ArchiveAffiliateNetworkResponse | PlainMessage<ArchiveAffiliateNetworkResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveAffiliateNetworkResponse, a, b);
  }
}

/**
 * NetworkNumbers is one partner's row of the list: the report's numbers for
 * the period (dimension «network», the engine GetBreakdownDrilldown runs), its
 * offers, whether its postbacks arrive and how many of its words are read.
 *
 * @generated from message tracker.v1.NetworkNumbers
 */
export class NetworkNumbers extends Message<NetworkNumbers> {
  /**
   * @generated from field: string network_id = 1;
   */
  networkId = "";

  /**
   * @generated from field: tracker.v1.StatsRow stats = 2;
   */
  stats?: StatsRow;

  /**
   * Offers of the partner that are not archived.
   *
   * @generated from field: int32 offer_count = 3;
   */
  offerCount = 0;

  /**
   * The newest postback journaled from the partner, ever (any result); "" =
   * the partner never sent one («не настроен»).
   *
   * @generated from field: string last_postback_at = 4;
   */
  lastPostbackAt = "";

  /**
   * «молчит»: the partner is active and has offers, and its newest postback
   * is older than silence_alert_seconds (or, with the alert set, there is
   * none) — without an alert, older than 30 days.
   *
   * @generated from field: bool silent = 5;
   */
  silent = false;

  /**
   * Words of the last 30 days and of the mapping (ListNetworkStatuses):
   * read (by the mapping or the global dictionary) and held as unknown.
   *
   * @generated from field: int32 status_words_known = 6;
   */
  statusWordsKnown = 0;

  /**
   * @generated from field: int32 status_words_unmapped = 7;
   */
  statusWordsUnmapped = 0;

  /**
   * Leads held as HOLD because their word is unmapped.
   *
   * @generated from field: int64 unmapped_leads = 8;
   */
  unmappedLeads = protoInt64.zero;

  constructor(data?: PartialMessage<NetworkNumbers>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.NetworkNumbers";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stats", kind: "message", T: StatsRow },
    { no: 3, name: "offer_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "last_postback_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "silent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "status_words_known", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "status_words_unmapped", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "unmapped_leads", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NetworkNumbers {
    return new NetworkNumbers().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NetworkNumbers {
    return new NetworkNumbers().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NetworkNumbers {
    return new NetworkNumbers().fromJsonString(jsonString, options);
  }

  static equals(a: NetworkNumbers | PlainMessage<NetworkNumbers> | undefined, b: NetworkNumbers | PlainMessage<NetworkNumbers> | undefined): boolean {
    return proto3.util.equals(NetworkNumbers, a, b);
  }
}

/**
 * ListNetworkNumbers answers the numbers of the partners on screen over the
 * app's one period, from the report engine (metrics are the registry's;
 * totals the engine's «Итого» of exactly these partners).
 *
 * @generated from message tracker.v1.ListNetworkNumbersRequest
 */
export class ListNetworkNumbersRequest extends Message<ListNetworkNumbersRequest> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: tracker.v1.AttributionBasis attribution_basis = 3;
   */
  attributionBasis = AttributionBasis.UNSPECIFIED;

  /**
   * Restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 4;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<ListNetworkNumbersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListNetworkNumbersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "attribution_basis", kind: "enum", T: proto3.getEnumType(AttributionBasis) },
    { no: 4, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListNetworkNumbersRequest {
    return new ListNetworkNumbersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListNetworkNumbersRequest {
    return new ListNetworkNumbersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListNetworkNumbersRequest {
    return new ListNetworkNumbersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListNetworkNumbersRequest | PlainMessage<ListNetworkNumbersRequest> | undefined, b: ListNetworkNumbersRequest | PlainMessage<ListNetworkNumbersRequest> | undefined): boolean {
    return proto3.util.equals(ListNetworkNumbersRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListNetworkNumbersResponse
 */
export class ListNetworkNumbersResponse extends Message<ListNetworkNumbersResponse> {
  /**
   * @generated from field: repeated tracker.v1.NetworkNumbers items = 1;
   */
  items: NetworkNumbers[] = [];

  /**
   * @generated from field: tracker.v1.StatsRow totals = 2;
   */
  totals?: StatsRow;

  constructor(data?: PartialMessage<ListNetworkNumbersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListNetworkNumbersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: NetworkNumbers, repeated: true },
    { no: 2, name: "totals", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListNetworkNumbersResponse {
    return new ListNetworkNumbersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListNetworkNumbersResponse {
    return new ListNetworkNumbersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListNetworkNumbersResponse {
    return new ListNetworkNumbersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListNetworkNumbersResponse | PlainMessage<ListNetworkNumbersResponse> | undefined, b: ListNetworkNumbersResponse | PlainMessage<ListNetworkNumbersResponse> | undefined): boolean {
    return proto3.util.equals(ListNetworkNumbersResponse, a, b);
  }
}

